<template>
	<div class="news">
			<div id="messaggio" style="position:fixed;top:0;left:0;width:100%;background-color:#3FFF82;color:#383838;z-index:9999;padding:0.7em;display:none;">
				<div>
				Grazie! La tua richiesta è stata inoltrata. Ti risponderemo a breve.
				</div>
			</div>
		<div class="section" id="trial">
			<div class="container-desktop pad-l">
				<h2 class="section-title">Prova gratuita</h2>

				<div class="grid">
					<div class="contact-form">
						<form class="pad-l" @submit.prevent="submitTrial">
							<div class="title">Prenota ora la tua PROVA GRATUITA!</div>

							<div class="input-grid">
								<div class="form-input">
									<label>Nome</label>
									<input type="text" v-model="formData.firstName" name="first_name" placeholder="Nome" id="nomeprova" required/>
								</div>

								<div class="form-input">
									<label>Cognome</label>
									<input type="text" v-model="formData.lastName" name="last_name" placeholder="Cognome" required/>
								</div>

								<div class="form-input">
									<label>Email</label>
									<input type="email" v-model="formData.email" name="email" placeholder="Email" required/>
								</div>

								<div class="form-input">
									<label>Cellulare</label>
									<input type="number" v-model="formData.phone" name="phone" placeholder="Cellulare" required/>
								</div>

								<div class="form-input">
									<label>Quale servizio vuoi provare?</label>
										<select v-model="formData.service">
											<option value="PT">Personal Training Singolo</option>
											<option value="COPPIA">Personal Training di Coppia</option>
											<option value="CLASS">Small Class</option>
										</select>
								</div>

								<div class="form-input">
									<label>Messaggio (opzionale)</label>
									<textarea rows="5" v-model="formData.message" name="message" placeholder="..."></textarea>
								</div>

								<div class="form-input">
									<label>Data</label>
									<input type="datetime-local" v-model="formData.when" name="when" required/>
								</div>

								<div class="submit">
									<button id="bottoneprova">PRENOTA</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>
			<div class="section" id="contacts">
				<div class="container-desktop pad-l">
					<h2 class="section-title">Contatti</h2>

					<div class="grid">

						<div class="where pad-l" id="contacts2">
							<div class="fixed-ratio">
								<iframe class="map" width="100%" height="100%" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2789.361942117139!2d9.201466850727428!3d45.64355277900088!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4786bd760f2a16fb%3A0xc1fbaaf39d2f23c9!2sEximus%20Performance!5e0!3m2!1sit!2sit!4v1584879476241!5m2!1sit!2sit" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
							</div>
						</div>

						<div class="how pad-l">
							<div class="where">
								<div>
									<span class="icon-md t-middle">room</span>
									<span class="t-middle"> Via Milano, 8, Seregno (MB)</span>
								</div>
							</div>

							<div class="contacts">
								<ul style="list-style-type: square;">
									<li>
										<span class="icon-md t-middle">mail</span>
										<span> Email:</span>
										<a class="mail t-middle" href="mailto:eximus.performance@gmail.com"> eximus.performance@gmail.com</a>
									</li>

									<li>
										<span class="icon-md t-middle">phone</span>
										<span> Coach Federico:</span>
										<a class="phone t-middle" href="tel:+393387118020"> +39 338 711 8020</a>
									</li>

									<li>
										<span class="icon-md t-middle">phone</span>
										<span> Coach Luca:</span>
										<a class="t-middle phone" href="tel:+393397606374"> +39 339 760 6374</a>
									</li>
								</ul>
								<p>Lunedì-Venerdì: 6.30-21.30<br>Sabato: 7.00-16.00</p>
							</div>

							<div class="socials">
								<div class="social-list">
									<a class="fab fa-facebook fa-fw" href="https://www.facebook.com/eximusperformance/" target="_blank"></a>
									<span> &bull; </span>
									<a class="fab fa-instagram fa-fw" href="https://www.instagram.com/eximus_performance/" target="_blank"></a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
	</div>
</template>

<script>
import api from '@/api'
import {notif} from '@/pop'
import Card from './Card'
import CookieLaw from 'vue-cookie-law'

export default {
	name: 'contacts',

	components: {
		Card,
		CookieLaw
	},

	data() {

		return {
			formData: {
				firstName: '',
				lastName: '',
				email: '',
				phone: '',
				service: 'PT',
				message: '',
				when: ''
			}
		}
	},

	methods: {
		/**
		 * Send trial request
		 */
		async submitTrial() {
			
			try
			{
				await api.make('POST', /* endpoint */'/public/trial', /* data */{
					first_name: this.formData.firstName,
					last_name: this.formData.lastName,
					email: this.formData.email,
					phone: this.formData.phone,
					service: this.formData.service,
					message: this.formData.message,
					when: this.formData.when
				}, /* bJson */true)

				/*notif.done('Grazie! La tua richiesta è stata inoltrata')*/
				this.$router.push('thankyou')
			}
			catch (e)
			{
				/*console.error('console error')
				notif.error('notif error')*/

  				/*document.getElementById("messaggio").style.display = "block";*/

				/*this.$router.push('thankyou')*/

			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.Cookie--base
	background #191f26
	font-size 1.1em

	p
		color #dcdcdc

		a
			color #dcdcdc

	.bottoni
		width 200px
		margin 0 auto

	button
		background #dcdcdc
		border #dcdcdc
		color #191f26
		padding 1em
		margin-right 10px
		font-size 1em
		border-radius 8px
	
	.accetta
		background #ffe010

.section
	background-color darkish

.grid
	display grid
	grid-template-columns 3fr 2fr

	@media (max-width: unit(media-phone-max, px))
		display block

	.fixed-ratio
		position relative

		padding-bottom 56%
		box-sizing border-box

		.map
			position absolute
	
	.contact-form
		grid-column 1/5

		margin 1.5em
		padding 2em

		background-color dark

		.title
			font-size 1.2em
		
		.input-grid
			margin-top 1.5em

			.form-input
				margin 0.5em 0

				box-sizing border-box
				
				label
					display block

					margin-bottom 0.4em

					font-size 0.8em

				input
					width 100%

					display block
				
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
				
				select
					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-size 1.2em
				
				textarea
					width 100%

					display block

					padding 0.4em 0.6em
					border none
					border-bottom 2px solid transparent
					box-sizing border-box

					background-color darkish
					color light

					font-family fontSans
					font-size 1.1em

					transition 0.2s ease

					&:focus
						outline none
						border-bottom 2px solid primary
			
			.submit
				margin-top 4em

				button
					width 100%

					padding 0.6em
					border none

					background-color primary
					color dark

					font-family fontSans
					font-size 1.3em

					cursor pointer

					transition 0.2s ease

					&:focus
						outline none

	.how
		.where
			margin-bottom 1em

			font-size 1.1em

	.contacts
		.mail
		.phone
			color lighten(secondary, 20%)

			text-decoration none

			&:hover
				text-decoration underline

	.socials
		.social-list
			display flex
			align-items center

			margin-top 0.2em
			margin-left 0.2em

			font-size 1.4em

			>a
				padding 0.3em

				color light

				text-decoration none

				transition 0.15s ease

				&:hover
					border-radius 50%

					background-color dark

					&.fa-facebook
						color #30C0F0
					&.fa-instagram
						color #D080D0
</style>